import Axios from "axios";
import {
  SET_EMPLOYEE_SUMMARY_REPORT_LIST,
  UNSET_EMPLOYEE_SUMMARY_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getEmployeeSummaryReport,
} from "@/store/api";

const state = {
  getEmployeeSummaryReport: [],
};

const getters = {
  getEmployeeSummaryReport(state) {
    return state.getEmployeeSummaryReport;
  },
};

const mutations = {
  [SET_EMPLOYEE_SUMMARY_REPORT_LIST](state, data) {
    state.getEmployeeSummaryReport = data;
  },
  [UNSET_EMPLOYEE_SUMMARY_REPORT_LIST](state) {
    state.getEmployeeSummaryReport = [];
  },
};

const actions = {
  getEmployeeSummaryReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeSummaryReport}`, { params: data })
        .then((response) => {
          commit(SET_EMPLOYEE_SUMMARY_REPORT_LIST, response.data.data);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_SUMMARY_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

